import { render, staticRenderFns } from "./payResult.vue?vue&type=template&id=29f89149&scoped=true&"
import script from "./payResult.js?vue&type=script&lang=js&"
export * from "./payResult.js?vue&type=script&lang=js&"
import style0 from "./payResult.vue?vue&type=style&index=0&id=29f89149&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f89149",
  null
  
)

export default component.exports